import Link from 'next/link';

const links = [
  { href: '/a-propos', label: 'À propos' },
  { href: '/confidentialite', label: 'Confidentialité' },
  { href: 'mailto:contact@namworks-studio.com', label: 'Contact' },
];

export default function AppFooter() {
  return (
    <footer className="no-print rounded-2xl border border-slate-800 bg-slate-950 px-4 py-4">
      <div className="flex flex-col gap-4 min-[520px]:flex-row min-[520px]:items-center min-[520px]:justify-between">
        <nav aria-label="Liens secondaires" className="flex flex-wrap gap-x-6 gap-y-3 text-sm font-medium text-slate-300">
          {links.map((link) =>
            link.href.startsWith('mailto:') ? (
              <a key={link.href} href={link.href} className="transition hover:text-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/30">
                {link.label}
              </a>
            ) : (
              <Link key={link.href} href={link.href} className="transition hover:text-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/30">
                {link.label}
              </Link>
            )
          )}
        </nav>
        <p className="text-xs text-slate-500 min-[520px]:text-right">© 2026 Namworks Studio. All rights reserved.</p>
      </div>
    </footer>
  );
}
